import { useEffect, useRef, useState } from 'react';
import { api, fmt, getUser } from '../api';
import { Modal, Field, Input, useToast, Loading } from '../ui';

export default function Prices() {
  const [types, setTypes] = useState<any[]>([]);
  const [data, setData] = useState<any>(null);
  const [search, setSearch] = useState('');
  const [onlyWithPrice, setOnlyWithPrice] = useState(false);
  const [brandId, setBrandId] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [brands, setBrands] = useState<any[]>([]);
  const [cats, setCats] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [typeModal, setTypeModal] = useState<any>(null);
  const [priceEdit, setPriceEdit] = useState<any>(null);
  const [importOpen, setImportOpen] = useState(false);
  const [importType, setImportType] = useState<number | null>(null);
  const fileRef = useRef<HTMLInputElement>(null);
  const toast = useToast();
  const user = getUser();
  const canEdit = ['admin', 'sotuv'].includes(user?.role);

  const loadTypes = () => api.get('/price-types').then(setTypes).catch((e) => { toast(e.message, true); setTypes([]); });
  const load = () => {
    const qs = new URLSearchParams({ page: String(page), pageSize: '25' });
    if (search) qs.set('search', search);
    if (onlyWithPrice) qs.set('onlyWithPrice', 'true');
    if (brandId) qs.set('brandId', brandId);
    if (categoryId) qs.set('categoryId', categoryId);
    api.get('/product-prices?' + qs.toString()).then(setData).catch((e) => { toast(e.message, true); setData({ items: [], total: 0, pageSize: 25 }); });
  };
  useEffect(() => {
    loadTypes();
    api.get('/brands').then(setBrands).catch(() => setBrands([]));
    // Kategoriyalar daraxti — indentli ro'yxatga yassilanadi
    api.get('/categories').then((tree) => {
      const flat: any[] = [];
      const walk = (nodes: any[], depth: number) => nodes.forEach((n) => {
        flat.push({ id: n.id, name: n.name, depth });
        if (n.children?.length) walk(n.children, depth + 1);
      });
      walk(tree, 0);
      setCats(flat);
    }).catch(() => setCats([]));
  }, []);
  useEffect(() => { load(); }, [page, onlyWithPrice, brandId, categoryId]);

  const saveType = async () => {
    try {
      if (typeModal.id) await api.patch('/price-types/' + typeModal.id, typeModal);
      else await api.post('/price-types', typeModal);
      toast('Saqlandi'); setTypeModal(null); loadTypes();
    } catch (e: any) { toast(e.message, true); }
  };
  const removeType = async () => {
    if (!confirm(`«${typeModal.name}» narx turi o'chirilsinmi? Kiritilgan qiymatlar ro'yxatdan yashiriladi.`)) return;
    try { await api.del('/price-types/' + typeModal.id); toast("O'chirildi"); setTypeModal(null); loadTypes(); load(); }
    catch (e: any) { toast(e.message, true); }
  };
  const savePrice = async () => {
    try { await api.post('/product-prices', priceEdit); toast('Narx saqlandi'); setPriceEdit(null); load(); }
    catch (e: any) { toast(e.message, true); }
  };
  const doImport = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; if (!file || !importType) return;
    try {
      const r = await api.upload('/product-prices/import', file, { priceTypeId: String(importType) });
      toast(`${r.updated} narx yangilandi, ${r.skipped} o'tkazildi`);
      setImportOpen(false); load();
    } catch (e: any) { toast(e.message, true); }
    if (fileRef.current) fileRef.current.value = '';
  };

  const totalPages = data ? Math.ceil(data.total / data.pageSize) : 1;
  const priceOf = (p: any, typeId: number) => p.productPrices.find((pp: any) => pp.priceTypeId === typeId);

  return (
    <div>
      <div className="page-head">
        <div><h1 className="page-title">Narxlar</h1><p className="page-sub">Narx turlari va mahsulot narxlari</p></div>
      </div>

      {/* Narx turlari */}
      <div className="card" style={{ marginBottom: 18 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>Narx turlari</h3>
          {canEdit && <button className="btn btn-primary btn-sm" onClick={() => setTypeModal({ currency: 'USD' })}>+ Narx turi yaratish</button>}
        </div>
        {types.length === 0 ? <p className="muted">Narx turlari kiritilmagan</p> : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {types.map((t) => (
              <span key={t.id} className="chip" style={{ cursor: canEdit ? 'pointer' : 'default' }} onClick={() => canEdit && setTypeModal({ ...t })}>
                {t.name} <span className="muted">({t.currency})</span>
              </span>
            ))}
          </div>
        )}
      </div>

      {/* Mahsulot narxlari */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h3 style={{ margin: 0 }}>Mahsulot narxlari</h3>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <label className="chip"><input type="checkbox" checked={onlyWithPrice} onChange={(e) => { setOnlyWithPrice(e.target.checked); setPage(1); }} /> Faqat narxi borlar</label>
          {canEdit && types.length > 0 && <>
            <input ref={fileRef} type="file" accept=".xlsx" hidden onChange={doImport} />
            <button className="btn" onClick={() => { setImportType(types[0]?.id ?? null); setImportOpen(true); }}>⬆ Excel import</button>
          </>}
        </div>
      </div>
      <form className="filters" onSubmit={(e) => { e.preventDefault(); if (page !== 1) setPage(1); else load(); }}>
        <input className="search" placeholder="Mahsulot / artikul bo'yicha qidirish" value={search} onChange={(e) => setSearch(e.target.value)} />
        <select className="input" style={{ width: 170 }} value={brandId} onChange={(e) => { setBrandId(e.target.value); setPage(1); }}>
          <option value="">Barcha brendlar</option>
          {brands.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
        <select className="input" style={{ width: 250 }} value={categoryId} onChange={(e) => { setCategoryId(e.target.value); setPage(1); }}>
          <option value="">Barcha kategoriyalar</option>
          {cats.map((c) => <option key={c.id} value={c.id}>{'  '.repeat(c.depth) + (c.depth > 0 ? '└ ' : '') + c.name}</option>)}
        </select>
        <button className="btn">Qidirish</button>
        {(search || brandId || categoryId || onlyWithPrice) && (
          <button type="button" className="btn btn-ghost" onClick={() => {
            setSearch(''); setBrandId(''); setCategoryId(''); setOnlyWithPrice(false); setPage(1);
          }}>Tozalash</button>
        )}
      </form>

      {!data ? <Loading /> : (
        <>
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Mahsulot</th>{types.map((t) => <th key={t.id} className="num">{t.name}</th>)}<th></th></tr>
              </thead>
              <tbody>
                {data.items.map((p: any) => (
                  <tr key={p.id}>
                    <td><b>{p.name}</b><div className="row-sub">{p.brand?.name || ''} · {p.article}</div></td>
                    {types.map((t) => { const pp = priceOf(p, t.id); return <td key={t.id} className="num">{pp ? fmt(pp.value, 2) + ' ' + pp.currency : '—'}</td>; })}
                    <td>{canEdit && <button className="btn btn-sm" onClick={() => setPriceEdit({ productId: p.id, productName: p.name, priceTypeId: types[0]?.id, currency: types[0]?.currency || 'USD' })}>+ narx</button>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="filters" style={{ marginTop: 14, justifyContent: 'flex-end' }}>
            <button className="btn btn-sm" disabled={page <= 1} onClick={() => setPage(page - 1)}>‹</button>
            <span className="muted">{page} / {totalPages}</span>
            <button className="btn btn-sm" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>›</button>
          </div>
        </>
      )}

      {importOpen && (
        <Modal title="Narxlarni Excel'dan yuklash" onClose={() => setImportOpen(false)}>
          <p className="muted" style={{ marginTop: -6 }}>
            Fayl ustunlari: <b>Artikul</b> va <b>Narx</b> (sarlavha qatori bilan).
            Tizim artikul bo'yicha mahsulotni o'zi topadi.
          </p>
          <Field label="Qaysi narx turiga yuklanadi">
            <select className="input" value={importType || ''} onChange={(e) => setImportType(+e.target.value)}>
              {types.map((t) => <option key={t.id} value={t.id}>{t.name} ({t.currency})</option>)}
            </select>
          </Field>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 6 }}>
            <button className="btn" onClick={() => setImportOpen(false)}>Bekor</button>
            <button className="btn btn-primary" disabled={!importType} onClick={() => fileRef.current?.click()}>
              📄 Faylni tanlash va yuklash
            </button>
          </div>
        </Modal>
      )}
      {typeModal && (
        <Modal title={typeModal.id ? 'Narx turi' : 'Yangi narx turi'} onClose={() => setTypeModal(null)}>
          <Field label="Nomi *"><Input value={typeModal.name || ''} onChange={(e) => setTypeModal({ ...typeModal, name: e.target.value })} /></Field>
          <Field label="Valyuta"><Input value={typeModal.currency || 'USD'} onChange={(e) => setTypeModal({ ...typeModal, currency: e.target.value })} /></Field>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            {typeModal.id && user?.role === 'admin' && (
              <button className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={removeType}>🗑 O'chirish</button>
            )}
            <button className="btn" onClick={() => setTypeModal(null)}>Bekor</button>
            <button className="btn btn-primary" onClick={saveType}>Saqlash</button>
          </div>
        </Modal>
      )}
      {priceEdit && (
        <Modal title={'Narx: ' + priceEdit.productName} onClose={() => setPriceEdit(null)}>
          <Field label="Narx turi">
            <select className="input" value={priceEdit.priceTypeId} onChange={(e) => { const t = types.find((x) => x.id === +e.target.value); setPriceEdit({ ...priceEdit, priceTypeId: +e.target.value, currency: t?.currency }); }}>
              {types.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </Field>
          <div className="grid-2">
            <Field label="Qiymat"><Input type="number" step="0.0001" value={priceEdit.value ?? ''} onChange={(e) => setPriceEdit({ ...priceEdit, value: e.target.value })} /></Field>
            <Field label="Valyuta"><Input value={priceEdit.currency || 'USD'} onChange={(e) => setPriceEdit({ ...priceEdit, currency: e.target.value })} /></Field>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button className="btn" onClick={() => setPriceEdit(null)}>Bekor</button>
            <button className="btn btn-primary" onClick={savePrice}>Saqlash</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
